import * as React from 'react';
import HtmlContent from '../_common/html-content';

function HomepageContent(props: HomepageContentProps) {
    const { snippet } = props;
    return (
        <section className="homepage-content page-section">
            <div className="page-section__inner">
                <div className="homepage-content__content">
                    <HtmlContent html={snippet} />
                </div>
            </div>
        </section>
    );
}

export default React.memo(HomepageContent);
